
import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_API_URL // same as the Url the server listens to
axios.defaults.timeout = 12000

import URI from 'urijs'
var URITemplate = require('urijs/src/URITemplate')


import { getInstance } from "../auth/index";

let ApiResponse = class {
    constructor(response) {

        this.data = response.data ?? [];

        this.totalCount = response.totalCount ?? 0;

        this.first = function() {
            return this.data.length > 0 ? this.data[0] : null;
        }
    }
}

let ApiEntityCollection = class {
    constructor(items) {

        this.data = items ?? [];

        this.totalCount = items ? items.length : 0;

    }
}


export default {

    getAuthService() {
        return getInstance()
    },

    getClientConfig() {

        let service = this.getAuthService();

        if (!service || service.loading || !service.isAuthenticated) {
            return new Promise(function(resolve) {
                resolve({});
            });
        } else {
            return service.getTokenSilently().then(token => {
                return {
                    access_token: token,
                    headers: {Authorization: `Bearer ${token}`}
                };
            });
        }

    },

    getOrganization ( id ) {

        let url = URITemplate("api/organizations/{orgId}").expand({
            orgId: id
        });

        return this.getClientConfig().then( config => {
            return axios.get(url, config);
        }).then(res => {
            let wrapper = new ApiResponse(res.data);
            return wrapper.first();
        })
    },

    deleteOrganization ( id ) {
        let url = URITemplate("api/organizations/{orgId}").expand({
            orgId: id,
        });

        return this.getClientConfig().then( config => {
            return axios.delete(url, config);
        }).then(res => {
            let wrapper = new ApiResponse(res.data);
            return wrapper.first();
        })
    },
    insertOrUpdateOrganization( entity) {

        let payload = new ApiEntityCollection([entity]);

        if(entity.organizationId) {
            let url = URITemplate("api/organizations/{orgId}").expand({
                orgId: entity.organizationId,
            });

            return this.getClientConfig().then( config => {
                return axios.put(url, payload, config);
            }).then(res => {
                let wrapper = new ApiResponse(res.data);
                return wrapper.first();
            })

        } else {
            let url = URITemplate("api/organizations").expand({
            });

            return this.getClientConfig().then( config => {
                return axios.post(url, payload, config);
            }).then(res => {
                let wrapper = new ApiResponse(res.data);
                return wrapper.first();
            })
        }
    },
    getOrganizationList () {

        let url = URITemplate("api/organizations").expand({
        });

        return this.getClientConfig().then( config => {
            return axios.get(url, config);
        }).then(res => {
            return new ApiResponse(res.data);
        });
    },

    getOrganizationUserAccount(orgId, id) {
        let url = URITemplate("api/organizations/{orgId}/users/{userId}").expand({
            orgId: orgId,
            userId: id
        });

        return this.getClientConfig().then( config => {
            return axios.get(url, config);
        }).then(res => {
            let wrapper = new ApiResponse(res.data);
            return wrapper.first();
        }).catch(function (error) {
            // handle error
            console.log(error);
            return null;
        })
    },
    getOrganizationUserAccountList ( id ) {

        let url = URITemplate("api/organizations/{orgId}/users").expand({
            orgId: id
        });

        return this.getClientConfig().then( config => {
            return axios.get(url, config);
        }).then(res => {
            return new ApiResponse(res.data);
        });
    },


    getAthlete( orgId, id ) {

        let url = URITemplate("api/organizations/{orgId}/athletes/{athleteId}").expand({
            orgId: orgId,
            athleteId: id
        });

        return this.getClientConfig().then( config => {
            return axios.get(url, config);
        }).then(res => {
            let wrapper = new ApiResponse(res.data);
            return wrapper.first();
        });

    },

    deleteAthlete( orgId, entity) {

        let url = URITemplate("api/organizations/{orgId}/athletes/{athleteId}").expand({
            orgId: orgId,
            athleteId: entity.athleteId
        });

        return this.getClientConfig().then( config => {
            return axios.delete(url, config);
        }).then(res => {
            let wrapper = new ApiResponse(res.data);
            return wrapper.first();
        })
    },

    insertOrUpdateAthlete( orgId, entity) {

        let payload = new ApiEntityCollection([entity]);

        if(entity.athleteId) {
            let url = URITemplate("api/organizations/{orgId}/athletes/{athleteId}").expand({
                orgId: orgId,
                athleteId: entity.athleteId
            });

            return this.getClientConfig().then( config => {
                return axios.put(url, payload, config);
            }).then(res => {
                let wrapper = new ApiResponse(res.data);
                return wrapper.first();
            })
        } else {
            let url = URITemplate("api/organizations/{orgId}/athletes").expand({
                orgId: orgId,
            });

            return this.getClientConfig().then( config => {
                return axios.post(url, payload, config);
            }).then(res => {
                let wrapper = new ApiResponse(res.data);
                return wrapper.first();
            })
        }
    },

    getAthleteList(orgId) {

        let url = URITemplate("api/organizations/{orgId}/athletes").expand({
            orgId: orgId,
        });

        return this.getClientConfig().then( config => {
            return axios.get(url, config);
        }).then(res => {
            return new ApiResponse(res.data);
        });

    },

    getSession( orgId, id ) {

        let url = URITemplate("api/organizations/{orgId}/athleteSessions/{sessionId}").expand({
            orgId: orgId,
            sessionId: id
        });

        return this.getClientConfig().then( config => {
            return axios.get(url, config);
        }).then(res => {
            let wrapper = new ApiResponse(res.data);
            return wrapper.first();
        });
    },
    deleteSession( orgId, entity) {

        let url = URITemplate("api/organizations/{orgId}/athleteSessions/{sessionId}").expand({
            orgId: orgId,
            sessionId: entity.sessionId
        });

        return this.getClientConfig().then( config => {
            return axios.delete(url, config);
        }).then(res => {
            let wrapper = new ApiResponse(res.data);
            return wrapper.first();
        })
    },
    getSessionList(orgId, athleteId, rangeLimit) {

        let url = URITemplate("api/organizations/{orgId}/athleteSessions").expand({
            orgId: orgId,
        });

        return this.getClientConfig().then( config => {
            return axios.get(url,
                {
                    params: { athleteId: athleteId ?? '', range: rangeLimit ?? 'all' },
                    ...config
                }
            );
        }).then(res => {
            return new ApiResponse(res.data);
        });

    },
    insertOrUpdateSession( orgId, entity) {

        let payload = new ApiEntityCollection([entity]);

        if(entity.sessionId) {
            let url = URITemplate("api/organizations/{orgId}/athleteSessions/{sessionId}").expand({
                orgId: orgId,
                sessionId: entity.sessionId
            });

            return this.getClientConfig().then( config => {
                return axios.put(url, payload, config);
            }).then(res => {
                let wrapper = new ApiResponse(res.data);
                return wrapper.first();
            })

        } else {
            //not supported
            return new Promise(resolve => resolve(null));
        }
    },

    insertOrUpdateUserAccount( userAccountId, entity) {
        let payload = entity;

        if(entity.userAccountId) {
            let url = URITemplate("api/userAccounts/{userAccountId}").expand({
                userAccountId: userAccountId
            });

            return this.getClientConfig().then( config => {
                return axios.put(url, payload, config);
            }).then(res => {
                let wrapper = new ApiResponse(res.data);
                return wrapper.first();
            })

        } else {
            //not supported
            return new Promise(resolve => resolve(null));
        }
    },

    getMeasurements(orgId, sessionId) {

        let url = URI(axios.defaults.baseURL + URITemplate("/api/organizations/{orgId}/measurement/{sessionId}").expand({
            orgId: orgId,
            sessionId: sessionId
        }))

        return this.getClientConfig().then( config => {
            return axios.get(url, config);
        }).then(res => {
            return res.data;
        }).catch(function (error) {
            // handle error
            console.log(error);
            return null;
        })
    },


    login() {

        let url = URI(axios.defaults.baseURL + URITemplate("/api/login").expand({
        }));

        return this.getClientConfig().then( config => {
            return axios.get(url, config);
        }).then(res => {
            //result should be user profile
            return res.data;
        })
    },
    ping() {

        let url = URI(axios.defaults.baseURL + URITemplate("/api/ping").expand({
        }));

        return this.getClientConfig().then( config => {
            return axios.get(url, config);
        }).then(res => {
            return res.data;
        });
    },

    inviteUser(organizationId, emailAddress, admin, notify) {

        let url = URI(axios.defaults.baseURL + URITemplate("/api/organizations/{orgId}/users/invite").expand({
            orgId: organizationId
        }))

        let payload = {
            emailAddress: emailAddress,
            admin: admin,
            notify: notify
        };

        return this.getClientConfig().then( config => {
            return axios.post(url, payload, config);
        }).then( x => {
            //result should be user profile
            return true || x;
        }).catch(function (error) {
            // handle error
            console.log(error);
            return false;
        })
    },

    removeUser(orgId, userId, notify) {

        let url = URI(axios.defaults.baseURL + URITemplate("/api/organizations/{orgId}/users/{userId}").expand({
            orgId: orgId,
            userId: userId
        })).addSearch("notify", notify ?? false)


        return this.getClientConfig().then( config => {
            return axios.delete(url, config);
        }).then( x => {
            //result should be user profile
            return true || x;
        }).catch(function (error) {
            // handle error
            console.log(error);
            return false;
        })

    },

    downloadMeasurementReport(orgId, sessionId, avg, format, units, includePDFReport, includeDataTables, includeExtendedDataTables ) {

        return this.getClientConfig().then( config => {
            let url = URI(axios.defaults.baseURL + URITemplate("/api/organizations/{orgId}/athleteSessions/{sessionId}/download").expand({
                orgId: orgId,
                sessionId: sessionId,
            }))
            .addSearch("access_token", config.access_token)
            .addSearch("avg", avg ?? 0)
            .addSearch("format", format ?? 'csv')
            .addSearch("units", units ?? 'kph');

            if (includePDFReport) {
                url.addSearch("report", "true");
            }
            if (includeDataTables) {
                url.addSearch("tables", "true");
            }
            if (includeExtendedDataTables) {
                url.addSearch("extendedTables", "true");
            }

            window.open(url.toString(), "_blank");
        });
    },

    getDashboard(orgId) {
        let url = URI(axios.defaults.baseURL + URITemplate("/api/organizations/{orgId}/dashboard").expand({
            orgId: orgId,
        }));

        return this.getClientConfig().then( config => {
            return axios.get(url, config);
        }).then(res => {
            return res.data;
        });
    },

    getAgreement(agreementType) {
        let url = URI(axios.defaults.baseURL + URITemplate("/api/agreements/{agreementType}").expand({
            agreementType: agreementType,
        }));

        return this.getClientConfig().then( config => {
            return axios.get(url, config);
        }).then(res => {
            return res.data;
        });
    },

    acceptAgreement(agreementType, agreementId) {
        let url = URI(axios.defaults.baseURL + URITemplate("/api/agreements/{agreementType}/accept/{agreementId}").expand({
            agreementType: agreementType,
            agreementId: agreementId,
        }));

        return this.getClientConfig().then( config => {
            return axios.post(url, {}, config);
        }).then(res => {
            return res.data;
        });
    }
}
